"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.BackgroundLayerPreview = void 0;
var _react = _interopRequireWildcard(require("react"));
var _Map = _interopRequireDefault(require("ol/Map"));
var _View = _interopRequireDefault(require("ol/View"));
var _Tile = _interopRequireDefault(require("ol/layer/Tile"));
var _Image = _interopRequireDefault(require("ol/layer/Image"));
var _util = require("ol/util");
var _antd = require("antd");
require("./BackgroundLayerPreview.less");
var _useMap = _interopRequireDefault(require("../Hook/useMap"));
var _MapComponent = _interopRequireDefault(require("../Map/MapComponent/MapComponent"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"]; if (null != _i) { var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1; try { if (_x = (_i = _i.call(arr)).next, 0 === i) { if (Object(_i) !== _i) return; _n = !1; } else for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0); } catch (err) { _d = !0, _e = err; } finally { try { if (!_n && null != _i["return"] && (_r = _i["return"](), Object(_r) !== _r)) return; } finally { if (_d) throw _e; } } return _arr; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
var BackgroundLayerPreview = function BackgroundLayerPreview(_ref) {
  var layer = _ref.layer,
    activeLayer = _ref.activeLayer,
    _ref$width = _ref.width,
    width = _ref$width === void 0 ? 128 : _ref$width,
    _ref$height = _ref.height,
    height = _ref$height === void 0 ? 128 : _ref$height,
    onClick = _ref.onClick,
    zoom = _ref.zoom,
    center = _ref.center,
    backgroundLayerFilter = _ref.backgroundLayerFilter;
  var previewLayer;
  if (layer instanceof _Tile["default"]) {
    previewLayer = new _Tile["default"]({
      source: layer.getSource()
    });
  } else if (layer instanceof _Image["default"]) {
    previewLayer = new _Image["default"]({
      source: layer.getSource()
    });
  }
  var mainMap = (0, _useMap["default"])();
  var _useState = (0, _react.useState)(new _Map["default"]({
      view: new _View["default"]({
        projection: mainMap === null || mainMap === void 0 ? void 0 : mainMap.getView().getProjection(),
        resolutions: mainMap === null || mainMap === void 0 ? void 0 : mainMap.getView().getResolutions(),
        center: center,
        zoom: zoom
      }),
      controls: [],
      interactions: [],
      layers: previewLayer && [previewLayer]
    })),
    _useState2 = _slicedToArray(_useState, 1),
    previewMap = _useState2[0];
  var _useState3 = (0, _react.useState)(false),
    _useState4 = _slicedToArray(_useState3, 2),
    loading = _useState4[0],
    setLoading = _useState4[1];
  (0, _react.useEffect)(function () {
    var setTrue = function setTrue() {
      return setLoading(true);
    };
    var setFalse = function setFalse() {
      return setLoading(false);
    };
    // @ts-ignore
    previewMap.on('loadstart', setTrue);
    // @ts-ignore
    previewMap.on('loadend', setFalse);
    return function () {
      // @ts-ignore
      previewMap.un('loadstart', setTrue);
      // @ts-ignore
      previewMap.un('loadend', setFalse);
    };
  }, [previewMap]);
  (0, _react.useEffect)(function () {
    if (zoom) {
      previewMap.getView().setZoom(zoom);
    }
    if (center) {
      previewMap.getView().setCenter(center);
    }
  }, [zoom, center]);
  var getBgLayersFromMap = function getBgLayersFromMap() {
    return (mainMap === null || mainMap === void 0 ? void 0 : mainMap.getLayerGroup().getLayers().getArray().filter(backgroundLayerFilter)) || [];
  };
  var updateBgLayerVisibility = function updateBgLayerVisibility(evt) {
    var _target$dataset;
    var target = evt === null || evt === void 0 ? void 0 : evt.currentTarget;
    var layerId = target === null || target === void 0 || (_target$dataset = target.dataset) === null || _target$dataset === void 0 ? void 0 : _target$dataset.uid;
    if (!layerId) {
      return;
    }
    var newBgLayer = mainMap === null || mainMap === void 0 ? void 0 : mainMap.getLayerGroup().getLayers().getArray().find(function (l) {
      return (0, _util.getUid)(l) === layerId;
    });
    if (!newBgLayer) {
      return;
    }
    getBgLayersFromMap().forEach(function (l) {
      return l.setVisible(false);
    });
    newBgLayer.setVisible(true);
    if (evt.type === 'click') {
      onClick(newBgLayer);
    }
  };
  var restoreBgLayerVisibility = function restoreBgLayerVisibility() {
    getBgLayersFromMap().forEach(function (l) {
      return l.setVisible(false);
    });
    activeLayer.setVisible(true);
  };
  var uid = (0, _util.getUid)(layer);
  var activeUid = (0, _util.getUid)(activeLayer);
  var isActive = uid === activeUid;
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "layer-preview".concat(isActive ? ' selected' : ''),
    key: uid,
    "data-uid": uid,
    onMouseOver: updateBgLayerVisibility,
    onMouseLeave: restoreBgLayerVisibility,
    onClick: updateBgLayerVisibility
  }, /*#__PURE__*/_react["default"].createElement(_antd.Spin, {
    spinning: loading
  }, /*#__PURE__*/_react["default"].createElement(_MapComponent["default"], {
    mapDivId: "previewmap-".concat(uid),
    style: {
      height: height,
      width: width
    },
    map: previewMap
  }), /*#__PURE__*/_react["default"].createElement("span", {
    className: "layer-title"
  }, layer.get('name'))));
};
exports.BackgroundLayerPreview = BackgroundLayerPreview;
var _default = BackgroundLayerPreview;
exports["default"] = _default;